import axiosInstance from './axios';

export const authService = {
  login: async (username, password) => {
    const response = await axiosInstance.post('/login', { username, password });
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },

  getCurrentUser: async () => {
    const response = await axiosInstance.get('/user');
    return response.data;
  },

  getStoredUser: () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },

  getToken: () => {
    return localStorage.getItem('token');
  },

  isAuthenticated: () => {
    return !!localStorage.getItem('token');
  },

  forgotPassword: async (email) => {
    const response = await axiosInstance.post('/forgot-password', { email });
    return response.data;
  },

  resetPassword: async (email, reset_code, password, password_confirmation) => {
    const response = await axiosInstance.post('/reset-password', {
      email,
      reset_code,
      password,
      password_confirmation,
    });
    return response.data;
  },
};
